import { render } from "./MediumTitle.vue?vue&type=template&id=c49db0ce"
import script from "./MediumTitle.vue?vue&type=script&lang=js"
export * from "./MediumTitle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__